module.exports = __webpack_public_path__ + "static/media/video-mock-reduced.cad3ee82.png";